import { api } from '../api'

/**
 * Tools data layer
 *
 * Provides methods to read and manipulate tools data
 * Depends on an API module that provides HTTP methods
 */
const ToolsAPI = () => {
  return {
    getAllTools,
    getToolDetails,
    createTool,
    updateTool,
    getcookiekeys,
    getToolJobs
  }

  async function getToolJobs(tool_id, limit, offset) {
    const response = await api.get(`/api/scrapery/tool_jobs/${tool_id}`, {
      params: {
        limit, offset
      }
    })

    return response
  }

  /**
   *
   * @returns
   */
  async function getToolDetails(id) {
    const tool = await api.get(`/api/scrapery/tools/${id}`)

    return tool
  }

  /**
   * Retrieve a list of all registered tool and their details
   */
  async function getAllTools(limit, offset, ordering, category) {
    const response = await api.get('/api/scrapery/tools', {
      params: {
        limit,
        offset,
        ordering,
        category
      },
    })

    if (Array.isArray(response)) {
      return response.map(
        tool => ({ ...tool, key: tool.id }),
      );
    }

    return {
      tools: response.results,
      count: response.count
    }
  }

  /**
   * Create a new tool
   * @param {object} toolDetails collected details of the tool
   * @returns success or error details
   */
  async function createTool(toolDetails) {
    const url = "/api/admin/tools"
    const data = compileFormData(toolDetails)
    // submit form data
    return await api.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
  }
  async function getcookiekeys(toolCookieDetails) {
    const url = "/api/scrapery/cookiekeys"

    return await api.get(url, { headers: { 'Content-Type': 'multipart/form-data' } })
  }

  /**
   * Edit a tool
   * @param {object} toolDetails collected details of the tool
   * @returns success or error details
   */
  async function updateTool(toolDetails, tool_id) {
    const url = "/api/admin/tools/" + tool_id
    const data = compileFormData(toolDetails)
    // submit form data 
    return await api.put(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
  }
}

const compileFormData = (toolDetails) => {
  const {
    name, details, category, type, cookie_key, spider_name, sample_input_file, sample_output_file, description, is_cookies_required
  } = toolDetails
  const data = new FormData()

  data.append("name", name)
  data.append("details", details)
  data.append("category", category)
  data.append("type", type)
  data.append("spider_name", spider_name)
  data.append("description", description)
  data.append("is_cookies_required", is_cookies_required)

  if (typeof cookie_key !== 'undefined' && cookie_key !== null) {
    data.append("cookie_key", cookie_key)
  }

  if (typeof sample_input_file === 'object' && sample_input_file != null) {
    data.append("sample_input_file", sample_input_file.originFileObj)
  }

  if (typeof sample_output_file === 'object' && sample_output_file != null) {
    data.append("sample_output_file", sample_output_file.originFileObj)
  }

  return data
}

export default ToolsAPI
